<template>
  <section class="panel pad">
    <div class="panel-head">
      <h2>论坛审核</h2>
      <button type="button" class="btn ghost sm" @click="load">刷新</button>
    </div>
    <p v-if="error" class="error">{{ error }}</p>
    <h3>待审主题（{{ pending.threads.length }}）</h3>
    <div v-for="item in pending.threads" :key="'t' + item.id" class="list-item">
      <div>
        <strong>{{ item.title }}</strong>
        <span class="muted"> · {{ item.author_email }} · {{ item.board }}</span>
        <p class="muted">{{ (item.body || '').slice(0, 120) }}</p>
      </div>
      <div>
        <button type="button" class="btn ghost sm" @click="reviewThread(item.id, 'published')">通过</button>
        <button type="button" class="btn ghost sm" @click="reviewThread(item.id, 'rejected')">驳回</button>
        <button type="button" class="btn ghost sm" @click="dropThread(item.id)">删除</button>
      </div>
    </div>
    <h3>待审回复（{{ pending.posts.length }}）</h3>
    <div v-for="item in pending.posts" :key="'p' + item.id" class="list-item">
      <div>
        <span class="muted">#{{ item.thread_id }} · {{ item.author_email }}</span>
        <p>{{ (item.body || '').slice(0, 160) }}</p>
      </div>
      <div>
        <button type="button" class="btn ghost sm" @click="reviewPost(item.id, 'published')">通过</button>
        <button type="button" class="btn ghost sm" @click="reviewPost(item.id, 'rejected')">驳回</button>
        <button type="button" class="btn ghost sm" @click="dropPost(item.id)">删除</button>
      </div>
    </div>
  </section>
</template>

<script>
import {
  adminForumPending,
  deleteForumPost,
  deleteForumThread,
  reviewForumPost,
  reviewForumThread
} from '../../api/platformService'

export default {
  name: 'AdminForumReview',
  data() {
    return {
      pending: { threads: [], posts: [] },
      error: ''
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.error = ''
      try {
        this.pending = await adminForumPending()
      } catch (err) {
        this.error = err.response?.data?.error || '加载待审失败'
        this.pending = { threads: [], posts: [] }
      }
    },
    async reviewThread(id, status) {
      await reviewForumThread(id, status)
      await this.load()
    },
    async reviewPost(id, status) {
      await reviewForumPost(id, status)
      await this.load()
    },
    async dropThread(id) {
      if (!window.confirm('删除该主题？')) return
      await deleteForumThread(id)
      await this.load()
    },
    async dropPost(id) {
      if (!window.confirm('删除该回复？')) return
      await deleteForumPost(id)
      await this.load()
    }
  }
}
</script>
